import titleLeft from "../assets/svg/title-left.svg";
import titleCenter from "../assets/svg/title-center.svg";
import titleRight from "../assets/svg/title-right.svg";
import productTitle1 from "../assets/svg/product-title-1.svg";
import productLabel from "../assets/svg/product-label.svg";
import settting from "../assets/svg/settting.svg";

export const SVGs = {
  titleLeft,
  titleCenter,
  titleRight,
  productTitle1,
  productLabel,
  settting,
};
